import React, { Component } from "react";
import Autocomplete from "react-autocomplete";

class CountryInput extends Component {
  render() {
    if (this.props.focus) {
      this.input.focus();
    }

    return (
      <div>
        <div className="menu--header">Filter by country codes</div>
        <div className="selected-countries">
          {this.props.countryCodes.map((o, index) => (
            <div 
              className="country-code"
              key={o.code}
              onClick={() => this.props.onDelete(index)}
            >
              {o.code}
              <i class="fas fa-times"></i>
            </div>
          ))}
        </div>
        <div className="input-container">
          <div className="country-input input-container autocomplete">
            <Autocomplete
              ref={ref => this.input = ref}
              getItemValue={item => item.name}
              items={this.props.countries}
              renderItem={(item, isHighlighted) => (
                <div
                  key={item.name}
                  className="suggestion"
                  style={{ background: isHighlighted ? "lightgray" : "white" }}
                >
                  {item.name + "  -  " + item.alpha2Code}
                </div>
              )}
              autoHighlight={true}
              inputProps={{
                tabIndex: this.props.tabIndex,
                placeholder: "e.g. Portugal",
              }}
              value={this.props.value}
              onChange={e => this.props.onChange(e.target.value)}
              onSelect={(val, item) => this.props.addCountry({name: item.name, code: item.alpha2Code})}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CountryInput;



// WEBPACK FOOTER //
// ./src/components/CountryInput.js